import { logAndylitics, log, logAPI} from "./andyliticsApi";
import * as tools from "../helpers/Tools";


const healthSourceApiBaseUrl = typeof window !== 'undefined' ? window.serverData.data.apiBaseUrl : ''; // window is undefined during pre-render

export const linkPharmacyAccount = (token, data) => {
    const url = encodeURI(tools.buildUrl( healthSourceApiBaseUrl, '/v3/HealthSource/Registration/LinkPharmacyAccount'));
    const params = {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        }
    };
    let start = new Date();

    //201 Created we are getting from Post success.
    return fetch(url, params).then(response => {
        if (response && response.status && (response.status === 200 || response.status === 201)) {
            logAPI("MBHWeb.Api.Rx.PharmacyAccount.Link", start, url);
            return response.json();
        } else {
            return Promise.reject(response);
        }
    }).catch(err => { logAPI("MBHWeb.Api.Rx.PharmacyAccount.Link.Failure", start, url, err); return Promise.reject(err); });
};

export const getUserTilesByClientData = (token) => {
    const url = encodeURI( tools.buildUrl( healthSourceApiBaseUrl, '/v1/HealthSource/AppTiles/GetUserTilesByClient'));
    const params = {
        method: 'get',
        headers: {
            'Authorization': 'bearer ' + token
        }
    };
    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.Dashboard.GetUserTilesByClient", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => { logAPI("MBHWeb.Api.Dashboard.GetUserTilesByClient.Failure", start, url, err); return Promise.reject(err); });
};

export const removeSlideTile = (tileId,token) => {  
    const url = tools.buildUrl( healthSourceApiBaseUrl, '/v1/HealthSource/AppTiles/DismissTile?tileId=' +tileId);
    const params = {
        method: "POST",
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
    };
    var start = new Date();
   
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.Settings.DismissTile", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => { logAPI("MBHWeb.Api.Settings.DismissTile.Failure", start, url, err); return Promise.reject(err); });
};


/**
 * getProviderFavorites
 * 
 * @param {string} userName = user's healthsource name
 * @param {string} token  = current user token
 * @returns {Promise} ResultStructure
 */
export const getProviderFavorites = (userName, token) => {
    const url = tools.buildUrl( healthSourceApiBaseUrl, '/v2/HealthSource/UserProvider/GetFavorites?userName=' + encodeURIComponent(userName));
    const params = {
        method: "GET",
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        //throw new Error("Testing sideways explosion!'");
        logAPI("MBHWeb.Api.Settings.Favorites.Full.Get", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(problems => {
        //debugger;
        logAPI("MBHWeb.Api.Settings.Favorites.Full.Get.Failure", start, url, problems); //changed the activityName as previous success log name
        return Promise.resolve( null);

    });
};

/**
 * removeProviderFromFavorites
 * 
 * @param {string} token  = current user token
 * @param {string} userName = user's healthsource name
 * @param {string} npi = npi of provider to remove
 * @returns {Promise} ResultStructure
 */
export const removeProviderFromFavorites = (token, userName, npi) => {
    const url = tools.buildUrl( healthSourceApiBaseUrl, '/v2/HealthSource/UserProvider/DeleteUserProvider');
    const params = {
        method: "POST",
        body: JSON.stringify({ProviderNPI: npi, IsFavorited: false, IsHidden: true, UserName: userName }),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.Settings.Favorite.Delete", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => { logAPI("MBHWeb.Api.Settings.Favorite.Delete.Failure", start, url, err); return Promise.reject(err); });
};

/**
 * addProviderToFavorites
 * 
 * @param {string} token  = current user token
 * @param {string} userName = user's healthsource name
 * @param {string} npi = npi of provider to add
 * @returns {Promise} ResultStructure
 */
export const addProviderToFavorites = (token, userName, npi) => {
    const url = tools.buildUrl( healthSourceApiBaseUrl, '/v2/HealthSource/UserProvider/SaveUserProvider');
    const params = {
        method: "POST",
        body: JSON.stringify({ ProviderNPI: npi, IsFavorited: true, IsHidden: false, UserName: userName }),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.Settings.Favorites.Save", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => { logAPI("MBHWeb.Api.Settings.Favorites.Save.Failure", start, url, err); return Promise.reject(err); });
};







/**
 * getCareTeam
 * 
 * @param {string} token  = current user token
 * @param {string} userName = user's healthsource name
 * @param {string} EPID = our login structure calls this EPID, we pass to epic as EID
 * @returns {Promise} ResultStructure
 */
export const getCareTeam = (token, userName, EPID) => {
    const url = tools.buildUrl( healthSourceApiBaseUrl, '/v2/Epic/GetCareTeamInfo?loginId=' + encodeURIComponent(userName) + '&patientId=' + EPID + '&patientIdType=EID');
    const params = {
        method: "GET",
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        //throw new Error("Eat my shorts, man!");
        logAPI("MBHWeb.Api.Setting.RecentProviders.Get", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(problems => {
        //debugger;
        // Log logAndylitics here
        logAPI("MBHWeb.Api.Setting.RecentProviders.Get.Failure", start, url, problems);
        return Promise.resolve(null);

        //alert("Oh crap!!");
    });
};

/**
 * autolinkMyChart
 * 
 * @param {string} token  = current user token
 * @param {string} userName = user's healthsource name
 * @param {string} dob = user's date of Birth
 * @returns {Promise} ResultStructure
 */
export const autolinkMyChart = (token, userName, dob) => {
    const url = tools.buildUrl( healthSourceApiBaseUrl, 'v2/HealthSource/Registration/LinkMyChart');
    const activityCode = "MBHWeb.Api.HealthSource.AutoLink.MyChart";
    const start = new Date();
    const data = { username: userName, dob: dob };
    const params = {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        }
    };
    return fetch(url, params).then(response => {
        logAPI(activityCode, start, url);
        if (response && response.status && response.status === 200)
            return response.text().length ? response.json() : { status: 200 };
        else return response.json();
    }).catch(err => { logAPI(activityCode+".Failure", start, url, err); return Promise.reject(err); });
};
